import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

interface ContainerProps {
	disabled?: boolean;
	loading?: boolean;
	animation?: boolean;
}

const hoverCardCss = css`
	transition: all 0.2s ease-out;
	box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
	top: -4px;
`;

const getCursor = (
	disabled?: boolean,
	loading?: boolean,
	animation?: boolean,
) => {
	if (disabled || animation === false) {
		return 'not-allowed';
	}
	if (loading) {
		return 'wait';
	}
	return 'pointer';
};

export const Container = styled.div<ContainerProps>`
	position: relative;
	width: 320px;
	height: 200px;
	box-shadow: 0px 10px 20px rgba(216, 222, 230, 0.5);
	border-radius: 6px;
	margin: 0 auto;
	padding: 52px 22px 22px 22px;
	display: flex;
	justify-content: space-between;
	align-items: space-between;
	flex-direction: column;
	background-color: ${({ disabled, loading }) =>
		disabled || loading ? '#F5F7FA' : tokens.color_white};
	cursor: ${({ disabled, loading, animation }) =>
		getCursor(disabled, loading, animation)};
	opacity: ${({ loading }) => loading && 0.9};

	:hover {
		${({ disabled, loading }) => !disabled && !loading && hoverCardCss}
	}
`;

export const ContainerIcon = styled.div<ContainerProps>`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 60px;
	margin-left: auto;
	margin-right: auto;
	top: -40px;
	left: 0;
	right: 0;
	text-align: center;
	background-color: ${tokens.color_primary};
	border-radius: 50%;
	opacity: ${({ loading }) => loading && 0.9};
`;

export const Title = styled.h2<{ loading?: boolean }>`
	font-weight: 600;
	font-size: 16px;
	color: ${tokens.color_primary};
	font-family: 'Montserrat';
	text-align: center;

	div:first-child {
		${({ loading }) =>
			loading &&
			css`
				background: #fff;
			`}
	}
`;

export const Subtitle = styled.h3`
	padding: 17px 0;
	font-weight: 600;
	font-family: 'Montserrat';
	color: ${tokens.color_gray_dark};
	font-size: 16px;
`;

export const ContainerDescription = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	svg {
		width: 32px;
		height: 32px;
	}
`;

export const Text = styled.p`
	font-family: 'Montserrat';
	font-weight: 500;
	font-size: 14px;
	color: ${tokens.color_gray_dark};
`;

export const IconSkeleton = styled.div`
	background-color: #a5daed;
	border-radius: 6px;
	width: 36px;
	height: 36px;
`;
